module.exports = __webpack_public_path__ + "img/HU24800880.ef50ffd5.png";